// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"260":"01a98542","891":"3c525638"}[chunkId] + ".css";
};